import React, { useState } from "react";

import axios from "axios";
import { Form, Button, Alert } from "react-bootstrap";
import swal from "sweetalert";

import "./Otp.css";

const OTPform = ({email}) => {
  const [otp, setOtp] = useState("");
  const [showMessage, setShowMessage] = useState(false);
  const [message, setMessage] = useState("");
  // const correctOtp = "123456";

  const handleOtpChange = (e) => {
    setOtp(e.target.value);
  };

  const handleVerify = async () => {
    try {
      const response = await axios.get(
        `https://api.tpdetector.com/api/admin/otp-verify?email=${email}&otp=${otp}`
      );

      if (response.status === 200) {
        const { token, user, message: successMessage } = response.data;
        localStorage.setItem("token", token);
        localStorage.setItem("user_id", user._id);
        localStorage.setItem("user_email", user.email);
        localStorage.setItem("user_role", user.role);
        // setShowPopup(true);
  


         swal("Success", "Successfully logged in", "success");
        setTimeout(() => {
          window.location.href = "/dashboard";
        }, 2000);
      
        
        setMessage(successMessage);
      }
    } catch (error) {
      if (error.response) {
        setMessage(error.response.data.message);
      } else {
        setMessage("An error occurred while processing your request.");
      }
    }
  };



  return (
    <div className="otp-container">
      <h3 className="otp-heading">Matching OTP Verification</h3>
      <Form>
        <Form.Group controlId="otp">
          <Form.Label className="otp-label">Enter OTP:</Form.Label>
          <Form.Control
            type="text"
            placeholder="Enter OTP"
            value={otp}
            onChange={handleOtpChange}
            maxLength={6}
            className="otp-input"
          />
        </Form.Group>
        <Button variant="primary" onClick={handleVerify} className="otp-button">
          Verify OTP
        </Button>
      </Form>
      {showMessage && (
        <Alert variant="success" className="otp-message">
          OTP Verified Successfully!
        </Alert>
      )}
    
    </div>

  );
};

export default OTPform;
